// extracted by mini-css-extract-plugin
module.exports = {"badge":"_7a3fb80146--badge--Ku9cj","badge-text":"_7a3fb80146--badge-text--WOJxg","badge-description":"_7a3fb80146--badge-description--GHkal"};